export default __webpack_public_path__ + "static/SupremeLL-Regular-6c28193be9dd61babf1771452752e555.woff";